<template>
  <tr>
    <th colspan="100%">
      <BaseLoadingBar height="2" />
    </th>
  </tr>
</template>

<script>
import { BaseLoadingBar } from "shared/components/base";

export default {
  name: "TableLoadingIndicator",
  components: {
    BaseLoadingBar,
  },
};
</script>

<style lang="scss" scoped>
tr {
  height: 0;

  th {
    padding: 0;
    border: none;
    height: 0;
    position: relative;

    :deep(.c-loading-bar) {
      position: absolute;
      bottom: 0;
      width: 100%;
    }
  }
}
</style>
